import { variablesToFieldsInfo } from '@microservices/wiskey-react-components'

import { TIME_LINE_MODE } from '@constants'
import { ActionJSScriptConfig, ObjectFieldDTO } from '@types'

type Props = {
  mode?: TIME_LINE_MODE
  columnsObjectFields?: ObjectFieldDTO[]
}

export const getTotalsCommandScriptConfig = (props: Props): ActionJSScriptConfig => {
  const { mode, columnsObjectFields } = props

  if (mode === TIME_LINE_MODE.DATE_TIME) {
    const variables = [
      { name: 'startDate', type: 'string' },
      { name: 'endDate', type: 'string' },
    ]

    return {
      examples: [
        {
          title: 'Roster Duty filter for interval',
          description: '',
          code: 'return `(duty_start_plan=ge=${srcObj.startDate});(duty_start_plan=le=${srcObj.endDate});staff_ref.dep_ref ==5;duty_type_plan_ref==А` ',
        },
      ],
      fieldsInfo: variablesToFieldsInfo(variables, 'srcObj'),
      variables,
    }
  }

  const variables = [
    {
      name: 'srcObj',
      type: [
        {
          name: 'item',
          type: !columnsObjectFields?.length
            ? 'any'
            : columnsObjectFields.map(field => {
                return {
                  name: field.name,
                  type: field.valueType,
                }
              }),
        },
      ],
    },
  ]

  return {
    examples: [
      {
        title: 'Roster Staff Qualification filter',
        description: '',
        code: 'return `qual_id_ref=="${srcObj.columnInfo.qual_id}"`',
      },
    ],
    fieldsInfo: variablesToFieldsInfo(variables, 'srcObj'),
    variables,
  }
}
